import { useEffect, useState } from 'react';
import { ShellComposerBridge } from '@robinpowered/dashboard-apps-common';
import { AuthBridge } from '../lib/authBridge';
import { registerApplications } from '../single-spa-config';

/**
 * Registers single-spa applications as soon as the import map is available in
 * the DOM. Accepts the auth + event-composer bridge instances created by
 * AppShell and forwards them to registerApplications, which passes them to each
 * app via customProps.
 */
export const useImportMapReady = (
  bridge: AuthBridge,
  composerBridge: ShellComposerBridge
): void => {
  const [importMapReady, setImportMapReady] = useState(
    () => !!document.querySelector('script[type="importmap"]')
  );

  useEffect(() => {
    if (importMapReady) {
      registerApplications(bridge, composerBridge);
      return;
    }

    const onReady = () => setImportMapReady(true);
    document.addEventListener('importmapready', onReady);
    return () => document.removeEventListener('importmapready', onReady);
  }, [importMapReady, bridge, composerBridge]);
};
